export const FEATURE_TO_COINS = {
  translation: 1,
  pronunciation: 1,
  example: 2,
  stt: 3,
  summarize: 30,
}
